var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-tag"},[_c('div',{staticClass:"dot"}),_c('div',[_c('span',[_vm._t("default",[_vm._v("Text")])],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }